export default "__VITE_ASSET__DqDIp_Gb__"